import React, { createContext } from 'react';
import { useAlerts } from '../hooks/useAlerts.js';

/**
 * Context to share alerts state across components
 */
export const AlertsContext = createContext();

/**
 * Provider component for alerts state
 */
export default function AlertsProvider({ children }) {
  const alertsState = useAlerts();

  return (
    <AlertsContext.Provider value={alertsState}>
      {children}
    </AlertsContext.Provider>
  );
}
